<template>
  <div class="myhome-profile">
    <div class="grid">
      <div class="xs-12 m-4 l-3 my-profile__sidebar">
        <SidebarLinkList :items="myProfileTypes" />
      </div>
      <router-view v-if="user && user.authenticated" :user="user"></router-view>
      <Loader v-else></Loader>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loader from "@/components/elements/Loader";
import SidebarLinkList from "@/components/elements/SidebarLinkList";

export default {
  name: "MyProfileHome",
  components: { Loader, SidebarLinkList },
  computed: {
    ...mapGetters(["user"]),
    myProfileTypes() {
      const color = this.user && this.user.targetCss ? this.user.targetCss.borderMod : "";
      const links = [];
      links.push({
        action: this.openRoute,
        active: this.$route.name === "my-profile-data",
        colorMod: color,
        name: "I miei dati",
        url: null,
        route: "my-profile-data",
      });
      if (this.user.teacher || this.user.principal) {
        links.push({
          action: this.openRoute,
          active: this.$route.name === "my-profile-schools",
          colorMod: color,
          name: this.user.teacher ? "Il mio lavoro" : "Le mie scuole",
          url: null,
          route: "my-profile-schools",
        });
      }
      if (this.user.parent) {
        links.push({
          action: this.openRoute,
          active: this.$route.name === "my-profile-family",
          colorMod: color,
          name: "La mia famiglia",
          // FIXME: Temporary set 'url'' value to the string below
          // url: null,
          url: "https://users.deascuola.it/#/user/signup/profile/family/3",
          route: "my-profile-family",
        });
      }
      if (this.user.student) {
        links.push({
          action: this.openRoute,
          active: this.$route.name === "my-profile-my-school",
          colorMod: color,
          name: "Io e la scuola",
          url: null,
          route: "my-profile-my-school",
        });
      }
      links.push({
        action: this.openRoute,
        active: this.$route.name === "my-profile-privacy" || this.$route.name === "my-profile-notifications",
        colorMod: color,
        name: this.user.parent_id ? "Notifiche" : "Privacy e notifiche",
        url: null,
        route: "my-profile-privacy",
      });
      if (!this.user.parent_id) {
        links.push({
          action: this.openRoute,
          active: this.$route.name === "my-profile-orders-panels" || this.$route.name === "orders-dea",
          colorMod: color,
          name: this.user.parent || this.user.student ? "I miei ordini ebook" : "I miei ordini",
          url: null,
          route: this.user.parent || this.user.student ? "orders-dea" : "my-profile-orders-panels",
        });
      }
      links.push({
        action: this.openRoute,
        active: this.$route.name === "my-profile-support",
        colorMod: color,
        name: this.user.teacher || this.user.principal ? "Assistenza e Agenzie" : "Assistenza",
        url: null,
        route: "my-profile-support",
      });
      return links;
    },
  },
  methods: {
    openRoute(item) {
      this.$router.push({ name: item.route });
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/system.utils";

.myhome-profile {
  padding-top: $space-large;
}

.my-profile {
  &__header {
    @include media("<=m") {
      flex-direction: column;
    }
    display: flex;
    margin: 0 0 $space-base;

    .dea-input {
      label {
        margin: 0;
      }
    }
  }

  &__title {
    flex-grow: 1;
    margin: 0;
  }

  &__sidebar {
    @include media("<=m") {
      margin-bottom: $space-large;
    }

    .dea-list-catalog__main-list {
      border-bottom: 0;
    }
  }
}

.dea-button.dea-button--hide-filters,
.dea-button.dea-button--show-filters {
  @include media(">s") {
    display: none !important; //sass-lint:disable-line no-important
  }
}

.dea-input.dea-input--margin-responsive {
  @include media("<=m") {
    display: flex;
    justify-content: flex-end;
    margin-top: $space-base;
    width: 100%;

    .dea-input__wrapper {
      max-width: $dea-size-xxx-large;
    }
  }
}
</style>
